declare let window: any;

export const isFlutterInAppWebView = (): boolean =>
  typeof window !== 'undefined' &&
  window.flutter_inappwebview?.callHandler !== undefined;

export const flutterNativeCall = async (
  name: string,
  args: Record<string, unknown> = {},
): Promise<boolean> => {
  if (!isFlutterInAppWebView()) return false;

  try {
    await window.flutter_inappwebview.callHandler('nativeCallback', name, [
      args,
    ]);
    return true;
  } catch (err) {
    console.error('[flutterNativeCall] Error calling Flutter handler:', err);
    return false;
  }
};
